export const BlockchainIconPath = `https://token-icons.dem.exchange/token-icons/blockchains/:blockchain_name.:file_type`
export const TokenIconPath = `https://token-icons.dem.exchange/token-icons/tokens/:token_name.:file_type`
